export const GET_FUEL_VENDOR_ACCOUNT = 'GET_FUEL_VENDOR_ACCOUNT';
export const GET_FUEL_VENDOR_NAMES = 'GET_FUEL_VENDOR_NAMES';
export const TOGGLE_FUEL_VENDOR_NAMES_LOADED = 'TOGGLE_FUEL_VENDOR_NAMES_LOADED';
export const UPDATE_FUEL_VENDOR_ACCOUNT = 'UPDATE_FUEL_VENDOR_ACCOUNT';
export const SAVE_FUEL_VENDOR = 'SAVE_FUEL_VENDOR';
export const TOGGLE_DUPLICATE_FUEL_VENDOR = 'TOGGLE_DUPLICATE_FUEL_VENDOR';
export const UPDATE_CREATED_FUEL_ID = 'UPDATE_CREATED_FUEL_ID';
export const TOGGLE_FUEL_DETAILS_LOADED = 'TOGGLE_FUEL_DETAILS_LOADED';
export const TOGGLE_SPINNER = 'TOGGLE_SPINNER';
export const DISCARD_FUEL_CHANGES = 'DISCARD_FUEL_CHANGES';
export const DISABLE_INTERACTIVE_FIELD = 'DISABLE_INTERACTIVE_FIELD';
export const DISABLE_SAVE_BUTTON = 'DISABLE_SAVE_BUTTON';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const CLEAR_FUEL_VENDOR = 'CLEAR_FUEL_VENDOR';
export const GET_FUEL_VENDOR_ACCOUNTS = 'GET_FUEL_VENDOR_ACCOUNTS';
export const DELETE_FUEL_VENDOR_ACCOUNT = 'DELETE_FUEL_VENDOR_ACCOUNT';
export const SET_SORT_ORDER = 'SET_SORT_ORDER';
export const SET_SORT_FIELD = 'SET_SORT_FIELD';
export const HIDE_SPINNER = 'HIDE_SPINNER';
export const DISPLAY_SNACKBAR = 'DISPLAY_SNACKBAR';
export const RESET_FUEL_VENDOR_ACCOUNT = 'RESET_FUEL_VENDOR_ACCOUNT';
export const TOGGLE_EDIT_DETAILS = 'TOGGLE_EDIT_DETAILS';
export const TOGGLE_FUEL_SPINNER = 'TOGGLE_FUEL_SPINNER';
export const TOGGLE_SUMMARY_SPINNER = 'TOGGLE_SUMMARY_SPINNER';
export const SET_SELECTED_FUEL_ACCOUNTS = 'SET_SELECTED_FUEL_ACCOUNTS';
export const SET_PREVIOUS_SELECTED_FUEL_ACCOUNTS = 'SET_PREVIOUS_SELECTED_FUEL_ACCOUNTS';
export const UNSET_PREVIOUS_SELECTED_FUEL_ACCOUNTS = 'UNSET_PREVIOUS_SELECTED_FUEL_ACCOUNTS';
export const RESET_PAGE_SIZE = 'RESET_PAGE_SIZE';
